import { Col, Row, Tabs, Table, Form, Space, DatePicker, Button, Tooltip, Tag, Skeleton } from 'antd';
import { ContentHeader } from "../../components";

const LoadingDetailPage = ({title} : {title?: string }) => {
    return (
        <section>
            <ContentHeader title={title ?? ""} />
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            defaultActiveKey="1" items={[
                                {
                                    key: "1",
                                    label: "",
                                    children:
                                        <div className="card card-body">
                                            <Row gutter={16}>
                                                <Col span="8">
                                                    <Skeleton.Image active />
                                                </Col>
                                                <Col span="8">
                                                    <Skeleton active />
                                                </Col>
                                                <Col span="8">
                                                    <Skeleton active />
                                                </Col>
                                            </Row>
                                        </div>
                                }
                            ]}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            defaultActiveKey="1" items={[
                                {
                                    key: "1",
                                    label: "",
                                    children:
                                        <Row>
                                            <Col span="24" className="card card-body">
                                                <Skeleton active />
                                            </Col>
                                        </Row>
                                }
                            ]}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card-outline">
                        <Tabs
                            defaultActiveKey="1" items={[
                                {
                                    key: "1",
                                    label: "",
                                    children:
                                        <Row>
                                            <Col span="24" className="card card-body">
                                                <Skeleton active />
                                            </Col>
                                        </Row>
                                }
                            ]}
                        />
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default LoadingDetailPage;
